import React from 'react';
import ArticleStatsRow from './ArticleStatsRow';
import styles from './ArticleStatsTable.module.css';
import useArticleStats from './ArticleStatsHook';

const ArticleStatsTable = () => {
  const articles = useArticleStats();

  // eslint-disable-next-line react/jsx-props-no-spreading
  const content = articles.map((props) => <ArticleStatsRow {...props} />);

  return (
    <table className={styles['article-stats-table']}>
      <thead className={styles.thead}>
        <tr>
          <th scope="col">Post title</th>
          <th scope="col">Visits</th>
          <th scope="col">Unlocked</th>
          <th scope="col">paid</th>
          {/* <th scope="col">CTR</th>
          <th scope="col">% Contrib</th> */}
        </tr>
      </thead>
      <tbody className={styles.tbody}>{content}</tbody>
    </table>
  );
};

export default ArticleStatsTable;
